<template>
  <section class="container py-5">
    <div class="row">
      <div class="col-md-12 mb-10">
        <div class="card border-0 shadow-sm">
          <div class="card-body p-4">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <h4 class="fw-bold text-dark">Détails du postulant</h4>
              <router-link to="/liste-offres" class="btn btn-primary">
                <i class="flaticon-left-arrow me-2"></i>Retour
              </router-link>
            </div>

            <div v-if="loading" class="text-center py-4">Chargement...</div>

            <div v-else-if="!candidater" class="text-center text-muted">
              Aucune donnée trouvée.
            </div>

            <div v-else class="row">
              <div class="col-md-6">
                <h5 class="fw-semibold mb-3">Informations personnelles</h5>
                <p><strong>Nom :</strong> {{ candidater.user?.nom }}</p>
                <p><strong>Prénom :</strong> {{ candidater.user?.prenom }}</p>
                <p><strong>Email :</strong> {{ candidater.user?.email }}</p>
                <p><strong>Téléphone :</strong> {{ candidater.user?.telephone || "Non renseigné" }}</p>
                <p><strong>Sexe :</strong> {{ candidater.user?.sexe || "Non renseigné" }}</p>
              </div>

              <div class="col-md-6">
                <h5 class="fw-semibold mb-3">Profil professionnel</h5>
                <p><strong>Qualification :</strong> {{ candidater.user?.qualification?.libelle || "Non spécifiée" }}</p>
                <p><strong>Expérience :</strong> {{ candidater.user?.anneeExperience || 0 }} ans</p>
                <p><strong>Date candidature :</strong> {{ formatDate(candidater.dateCandidature) }}</p>
                <p><strong>Statut :</strong>
                  <span class="badge bg-success" v-if="candidater.estSelectionner">Sélectionné</span>
                  <span class="badge bg-secondary" v-else>Non sélectionné</span>
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import ApiService from "@/services/ApiService";

export default defineComponent({
  name: "CandidaterDetailsPage",
  setup() {
    const route = useRoute();
    const candidater = ref<any>(null);
    const loading = ref(true);

    const fetchDetails = async () => {
      loading.value = true;
      try {
        const { data } = await ApiService.get(`/candidaters/${route.params.id}`);
        candidater.value = data.data;
      } catch (error) {
        console.error("Erreur:", error);
      } finally {
        loading.value = false;
      }
    };

    const formatDate = (date: string) =>
      new Date(date).toLocaleDateString("fr-FR", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });

    onMounted(fetchDetails);

    return { candidater, loading, formatDate };
  },
});
</script>
